// extracted by mini-css-extract-plugin
module.exports = {"bundle-item":"ProductItem_bundle-item__sJLBz","single":"ProductItem_single__TNFiY"};